import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";

export const LockNotice = ({ message, ctaTo, ctaLabel, ctaState }) => {
  const { t } = useTranslation();
  return (
    <div className="mb-4 flex items-start gap-2.5 rounded-md border border-amber-200 bg-amber-50 px-3.5 py-3" data-testid="lock-notice">
      <Lock className="h-4 w-4 text-amber-600 shrink-0 mt-0.5" />
      <div>
        <p className="text-sm font-medium text-amber-800">{t("auth.accountLocked")}</p>
        <p className="text-xs text-amber-700 mt-0.5">{t("auth.lockedHelp")} {message}</p>
        {ctaTo && (
          <Link to={ctaTo} state={ctaState} className="mt-2 inline-block text-xs font-medium text-amber-900 underline hover:no-underline" data-testid="lock-reset-link">
            {ctaLabel}
          </Link>
        )}
      </div>
    </div>
  );
};
